import styled, { css } from 'styled-components';
import { Size } from './HeaderTabSelector.component';

export const List = styled.ul`
  display: flex;
`;

const ButtonActiveStyle = css<{ size: Size }>`
  &:not(:hover):after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colors['primary-60']};
    width: 4px;
    height: 4px;
    border-radius: 50%;
    display: block;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const Button = styled.button<{ active?: boolean; size: Size }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme, active }) =>
    active ? theme.colors['primary-60'] : theme.colors['neutral-80']};
  position: relative;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  padding: 4.5px 11px;

  &:hover {
    border-color: ${({ theme }) => theme.colors['neutral-40']};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors['neutral-60']};
  }

  ${({ active }) => active && ButtonActiveStyle}
`;
